// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const CodeBrackets_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M8.133 4.153 3.139 12l4.994 7.847a.75.75 0 0 1-.23 1.036A.74.74 0 0 1 7.5 21a.75.75 0 0 1-.634-.348l-5.25-8.25a.75.75 0 0 1 0-.805l5.25-8.25a.75.75 0 1 1 1.266.805Zm14.25 7.445-5.25-8.25a.75.75 0 1 0-1.266.805L20.861 12l-4.994 7.847a.75.75 0 0 0 .23 1.036.74.74 0 0 0 .403.117.75.75 0 0 0 .634-.348l5.25-8.25a.75.75 0 0 0-.001-.804Z',
  viewBox: '0 0 24 24',
  glyph: 'CodeBrackets_Stroke2_Corner0_Rounded',
})

export const CodeBrackets_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M8.133 4.153 3.139 12l4.994 7.847a.75.75 0 0 1-.23 1.036A.74.74 0 0 1 7.5 21a.75.75 0 0 1-.634-.348l-5.25-8.25a.75.75 0 0 1 0-.805l5.25-8.25a.75.75 0 1 1 1.266.805Zm14.25 7.445-5.25-8.25a.75.75 0 1 0-1.266.805L20.861 12l-4.994 7.847a.75.75 0 0 0 .23 1.036.74.74 0 0 0 .403.117.75.75 0 0 0 .634-.348l5.25-8.25a.75.75 0 0 0-.001-.804Z',
  viewBox: '0 0 24 24',
  glyph: 'CodeBrackets_Stroke2_Corner2_Rounded',
})

export const CodeLines_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'm5.47 9.53-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 1.06L4.06 6l2.47 2.47a.75.75 0 0 1-1.06 1.06Zm3.75 0a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 0 0-1.06 1.06L11.69 6 9.22 8.47a.75.75 0 0 0 0 1.06Zm9.53-5.78H16.5a.75.75 0 0 0 0 1.5h2.25v13.5H5.25v-6a.75.75 0 0 0-1.5 0v6a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5Z',
  viewBox: '0 0 24 24',
  glyph: 'CodeLines_Stroke2_Corner2_Rounded',
})
